import { SubmitHandler, useForm } from "react-hook-form";
import FormButton from "../../Components/Buttons/FormButton";
import FormSelect from "../../Components/FormTag/FormSelect";
import FormToggle from "../../Components/FormTag/FormToggle";
import InputFiled from "../../Components/FormTag/InputFiled";
import { formSelectOptionList } from "../../Utility/Utility";
import { ItemsAttributeData } from "./model/items.model";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { lookUpService } from "../../Services/common/lookup.service";
import { SelcetOption } from "../../model/common/apiResponse";

interface ItemsAttributeProp {
  handleNext: () => void;
  lookupData?: any;
  onSubmit: (data: any) => void;
  initialData?: ItemsAttributeData | null;
}

export default function ItemsAttribute(props: ItemsAttributeProp) {
  console.log("lookup Data", props.lookupData);
  const { handleNext, onSubmit, initialData } = props;
  const [fifoDateMethodList, setFifoDateMethodList] = useState();
  const [fifoMethodList, setFifoMethodList] = useState();
  const [serialTrackingList, setSerialTrackingList] = useState();
  const [popularityList, setPopularityList] = useState();
  const [countryList, setCountryList] = useState<SelcetOption[]>([]);
  const navigation = useNavigate();
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<ItemsAttributeData>({
    defaultValues: initialData || ItemsAttributeData,
  });
  const dropDowndata = async () => {
    await fetchCountryData();
    setFifoMethodList(formSelectOptionList(props.lookupData.fifo_method));
    setFifoDateMethodList(
      formSelectOptionList(props.lookupData.fifo_date_method)
    );
    setSerialTrackingList(
      formSelectOptionList(props.lookupData.serial_tracking)
    );
    setPopularityList(formSelectOptionList(props.lookupData.popularity));
  };

  useEffect(() => {
    dropDowndata().then(() => {
      if (initialData) {
        initialData.fifo_date_method = initialData.fifo_date_method?.code;
        initialData.fifo_method = initialData.fifo_method?.code;
        initialData.serial_tracking = initialData.serial_tracking?.code;
        initialData.popularity = initialData.popularity?.code;
        if (initialData.country_of_origin && initialData.country_of_origin?.code) {
          initialData.country_of_origin = initialData.country_of_origin?.code;
        }
        reset(initialData);
      }
    });
  }, []);
  const fetchCountryData = async () => {
    try {
      const countryData = await lookUpService.countryLookup();
      console.log(countryData?.data?.data);


      const countryList: SelcetOption[] =
        countryData.data?.data?.map((obj: any) => ({
          label: obj.name,
          value: obj.code,
        }));
      setCountryList(countryList);
    } catch (error) {

    }
  };
  const nextData: SubmitHandler<ItemsAttributeData> = async (data) => {
    if (data.fifo_date_method) {
      data.fifo_date_method = {
        code: data.fifo_date_method,
      };
    }
    if (data?.country_of_origin && Object.keys(data?.country_of_origin) && data?.country_of_origin?.code) {
      data.country_of_origin = {
        code: data.country_of_origin,
      };
    } else {
      delete data?.country_of_origin;
    }
    if (data.fifo_method) {
      data.fifo_method = {
        code: data.fifo_method,
      };
    }
    if (data.serial_tracking) {
      data.serial_tracking = {
        code: data.serial_tracking,
      };
    }
    if (data.popularity) {
      data.popularity = {
        code: data.popularity,
      };
    }
    //  reset(data);
    await props.onSubmit(data);
    handleNext();
  };

  const handelCancelBtn = () => {
    navigation("/account/client/items");
  };

  return (
    <>
      <form>
        <div className="my-2 bg-white rounded p-3">
          <div className="d-flex px-2 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">FIFO Method *</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={5}
                  name="fifo_method"
                  control={control}
                  optionList={fifoMethodList}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                  required={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">FIFO Date Method * </label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={6}
                  name="fifo_date_method"
                  control={control}
                  optionList={fifoDateMethodList}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                  required={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2 d-flex">
              <div className="col-4 item-toggle-btn">
                <label className="fw-medium">Tag #</label>
                <div className="mt-1">
                  <FormToggle register={register} name="is_tag_tracking" />
                </div>
              </div>
              <div className="col-4 item-toggle-btn">
                <label className="fw-medium">Lot #</label>
                <div className="mt-1">
                  <FormToggle register={register} name="is_lot_tracking" />
                </div>
              </div>
              <div className="col-4 item-toggle-btn">
                <label className="fw-medium">Track Expiry</label>
                <div className="mt-1">
                  <FormToggle register={register} name="is_expiry_tracking" />
                </div>
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Serial Tracking *</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={5}
                  name="serial_tracking"
                  control={control}
                  optionList={serialTrackingList}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                  required={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Min Stock Level</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={2}
                  type="text"
                  register={register}
                  name="min_stock_level"
                  errors={errors.min_stock_level}
                  className="form-control"
                  placeholder="Enter Min Stock Level"
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Max Stock Level</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={3}
                  type="text"
                  register={register}
                  name="max_stock_level"
                  errors={errors.max_stock_level}
                  className="form-control"
                  placeholder="Enter Max Stock Level"
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Sugg. Stock Level</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={4}
                  type="text"
                  register={register}
                  name="suggested_stock_level"
                  errors={errors.suggested_stock_level}
                  className="form-control"
                  placeholder="Enter Sugg. Stock Level"
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Country Of Origin</label>
              <div className="mt-1">
                <FormSelect
                  name="country_of_origin"
                  autofocus={true}
                  tabIndex={7}
                  control={control}
                  optionList={countryList ?? []}
                  className="form-control p-0 "
                  placeholder="Select"
                  isSearchable={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label>Item Popularity</label>
              <div className="mt-2">
                <FormSelect
                  name="popularity"
                  tabIndex={7}
                  control={control}
                  optionList={popularityList}
                  className="form-control p-0"
                  placeholder="Select"
                // isSearchable={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Shelf life</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={4}
                  type="text"
                  register={register}
                  name="shelf_life"
                  className="form-control"
                  placeholder="Enter Shelf Life"
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Ship Life</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={4}
                  type="text"
                  register={register}
                  name="ship_life"
                  className="form-control"
                  placeholder="Enter Ship Life"
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            {/* <div className="col-4 px-2">
              <label className="fw-medium">Track Expiry</label>

              <FormToggle
                register={register}
                name="is_expiry_tracking"
              />
            </div> */}

            <div className="col-4 px-2"></div>
          </div>
        </div>
        <div className="my-2 bg-white rounded py-3">
          <div className="d-flex flex-row-reverse">
            <FormButton
              tabIndex={15}
              className="sph-btn me-4"
              handleClick={handleSubmit(nextData)}
            >
              Submit
            </FormButton>
            <FormButton
              tabIndex={26}
              className="sph-btn sph-shift me-4"
              handleClick={handelCancelBtn}
            >
              Cancel
            </FormButton>
          </div>
        </div>
      </form>
    </>
  );
}
